import get from "lodash/get";
import set from "lodash/set";

export const getValidationErrors = (error) => {
  const errors = {};

  if (!error.graphQLErrors) {
    return [error];
  }

  error.graphQLErrors.forEach((graphQLError) => {
    try {
      JSON.parse(graphQLError.message).forEach(({ key, message }) => {
        const resolvedKey = key || "general";
        set(errors, resolvedKey, get(errors, resolvedKey, []).concat(message));
      });
    } catch (e) {
      set(
        errors,
        "general",
        get(errors, "general", []).concat(graphQLError.message)
      );
    }
  });

  return errors;
};

export const getUnifiedValidationErrors = (error) =>
  Object.values(getValidationErrors(error)).reduce(
    (acc, errors) => [...acc, ...errors],
    []
  );
